import React from "react";
import {
  Box,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text
} from "@chakra-ui/react";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import AppButton from "@/features/line-sheet-sets/app-button";
import useIdentity from "@/features/ui/hooks/use-identity";
import AppCompanySelect from "@/features/line-sheet-sets/app-company-select";
import SVG from "react-inlinesvg";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  initialValues: any[];
  saveSelectedBrand: (brands: any[], lineSheetId: number) => void;
  lineSheetId: number;
}

export default function BrandSelectModal({ isOpen, onClose, initialValues, saveSelectedBrand, lineSheetId }: Props) {
  const { t, tTitle } = useI18nHelper();
  const identity = useIdentity();
  const [ tmpBrands, setTmpBrands ] = React.useState<any[]>([]);
  React.useEffect(() => {
    setTmpBrands(initialValues.map((item) => {
      return {
        id: item.id,
        name: item.name,
      };
    }));
  }, [initialValues]);


  const handleClose = () => {
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader background={"#F7F9FA"} padding={"12px 16px"} borderRadius={"8px 8px 0 0"}>
          <Text textStyle={"body-md-bold"} color={"#444444"}>
            {tTitle("select_brand")}
          </Text>
        </ModalHeader>
        <ModalBody display="flex" flexDirection={"column"} gap={"24px"} paddingLeft={"16px"}>
          <Flex flexDirection="column" gap={"24px"}>
            <Flex flexDirection={"column"} gap={"6px"}>
            <Text textStyle={"body-sm-bold"} color={"#444444"}>{tTitle("brand")}</Text>
            <AppCompanySelect
              types={["BRAND"]}
              name={tTitle(
                "common\:brand"
              )}
              isMultiple={true}
              id={tmpBrands.map((item) => item.id)}
              width={"100%"}
              isClearable={false}
              onSelect={(value) => {
                if (!value) {
                  return;
                }
                setTmpBrands(value.map((item) => {
                  return {
                    id: item.id,
                    name: item.name,
                  };
                }));
              }}
            />
            </Flex>
          </Flex>
          { tmpBrands.length > 0 &&
            <Flex gap={"12px"} flexWrap={"wrap"} border={"1px solid #E4E4E4"} borderRadius={"4px"} padding={"12px"}>
              {tmpBrands.map((item) => {
                return (
                  <Flex
                    key={item.id}
                    background={"#F7F9FA"}
                    borderRadius={"4px"}
                    padding={"4px 8px"}
                    gap={"8px"}
                    alignItems={"center"}
                  >
                    <Text textStyle={"body-sm-bold"} color={"#444444"}>
                      {item.name}
                    </Text>
                    <SVG
                      src={"/icons-v1_1/x.svg"}
                      width={"16px"}
                      height={"16px"}
                      onClick={() => {
                        setTmpBrands((prev) => prev.filter((brand) => brand.id !== item.id));
                      }}
                      cursor={"pointer"}
                    />
                  </Flex>
                );
              })}
            </Flex>
          }
        </ModalBody>
        <ModalFooter display={"flex"} justifyContent={"space-between"} gap={"12px"} paddingLeft={"8px"}>
          <AppButton
            key={"Brand_ResetFilter"}
            variant={"ghost"}
            size={"medium"}
            onClick={() => {
              setTmpBrands([]);
            }}
            width={"72px"}
            height={"28px"}
          >
            <Flex gap={"4px"} alignItems={"center"}>
              <SVG
                src={"/icons-v1_1/arrow-rotate.svg"}
                width={"16px"}
                height={"16px"}
                color={"#8F8F8C"}
              />
              <Text textStyle="body-sm-bold" color={"#444444"}>
                {t("clear_all")}
              </Text>
            </Flex>
          </AppButton>
          <Box display="flex" gap="12px">
            <AppButton variant={"normal"} onClick={handleClose}>
              <Text textStyle={"body-sm-bold"} color={"#444444"}>
                {tTitle("cancel")}
              </Text>
            </AppButton>
            <AppButton
              variant={"primary"}
              onClick={async () => {
                if (!identity) {
                  handleClose();
                  return;
                }
                try {
                  saveSelectedBrand(tmpBrands, lineSheetId);
                  handleClose();
                } catch (e) {
                  console.error(e);
                }
              }}
            >
              <Text textStyle={"body-sm-bold"} color={"#FFFFFF"}>
                {tTitle("save")}
              </Text>
            </AppButton>
          </Box>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
